import React, { useContext, useState, useEffect } from "react";
import { StateContext } from "../../../context/StateContext";
import Loading from "../../../components/loading/loading";
import Logs from "./Logs";
import Header from "../../../components/header/header";

const CHANNELS_COUNT = 14;

const ImpactDuration = () => {
  const STATE = useContext(StateContext);
  const [bells, setBells] = useState([]);
  const showAllChannels = STATE.lastData.settings.version === 5.2;
  const visibleCount = showAllChannels
    ? CHANNELS_COUNT
    : STATE.lastData.settings.count;

  const changeTime = (index, move) => {
    let newBells = [...bells];
    const time = newBells[index].time;

    if (move === "dec") {
      if (time > 0) {
        newBells[index].time = newBells[index].time - 1;
      }
    } else {
      if (time < 255) {
        newBells[index].time = newBells[index].time + 1;
      }
    }

    setBells(newBells);
  };

  const bellsList = bells.map((bell, index) => {
    if (index < visibleCount) {
      return (
        <div className="force-item" key={index}>
          <div className="force-num">№ {index + 1}</div>
          <div className="force-count-area">
            <div className="dec" onClick={() => changeTime(index, "dec")}>
              -
            </div>
            <div className="count">{bell.time}</div>
            <div className="inc" onClick={() => changeTime(index, "inc")}>
              +
            </div>
          </div>
        </div>
      );
    } else return "";
  });

  useEffect(() => {
    const newBells = [];

    STATE.lastData.bells.forEach((bell) => {
      newBells.push({ power: bell.power, time: bell.time });
    });
    setBells(newBells);
  }, []);

  const save = (e) => {
    STATE.sendData({ bells });
  };

  return (
    <div className="main-area-field full-height">
      <div className="main-area full-height">
        <div className="page-area no-p">
          <Header
            title={"Задержка"}
            backTitle="Настройки"
            backUrl={`/device/${STATE.subscribed.id}/settings`}
          />
          <Logs />

          <div className="page-area center-h">
            <div className="content">
              <div className="block force-block">
                <div className={`force-list${showAllChannels ? " _channels" : ""}`}>
                  {bellsList}
                </div>
              </div>
              <div className="button-area _center">
                <button
                  className="btn btn-yellow chimes-save"
                  onClick={(e) => save(e)}
                >
                  {!STATE.isSending && "СОХРАНИТЬ"}
                  {STATE.isSending && <Loading />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactDuration;
